export default class {
    constructor(Component) {
        this.Component = Component;
    }

    group(type, label, content) {
        return App.Template.parse('overview-filter-group', {
            type:       type,
            label:      label,
            content:    content,
        });
    }

    item(key, label, unique) {
        let template = unique ? 'overview-filter-item-unique' : 'overview-filter-item-multiple';
        return App.Template.parse(template, {
            key:    key,
            label:  label,
            id:     key + Math.floor(Math.random() * 9999),
        });
    }
}
